import React from 'react';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Logs from 'components/Logs';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Brokers from 'components/Brokers';
import { useSelector } from 'react-redux';
import Comments from 'components/Comments';
import { useStyles } from './Details.styled';
import { useParams } from 'react-router-dom';
import { PaymentWidget } from 'components/Payment';
import { Grid, Container } from '@material-ui/core';

const PaymentDetails = () => {
  const classes = useStyles();
  const { id } = useParams();

  const { payment, transaction } = useSelector((state) => ({
    payment: state.payment.current,
    transaction: state.transaction.current,
  }));

  // Check if we need to call payments or transaction
  const sharingType = useSelector(
    (state) => state.config?.settings?.core?.partnership?.sharing_type
  );
  const core = useSelector((state) => state.config?.settings?.core || {});
  const hasPartnership = core?.partnership?.enabled || false;
  const isFFBEnabled = sharingType === 'FFB' && hasPartnership;

  const current = isFFBEnabled ? transaction : payment;
  const paymentType = isFFBEnabled ? 'Transaction' : 'payment';

  return (
    <Layout title={i18n.t('payments.title')}>
      <Container className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} direction="row" alignItems="center">
              <Grid item>
                <Title
                  title={`${i18n.t('payments.details')} - ${i18n.t('payments.id', {
                    id,
                  })}`}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <PaymentWidget id={+id} />
                  </Grid>
                  <Can I="read" on={paymentType}>
                    <Grid item xs={12}>
                      <Brokers brokers={current?.brokers || {}} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              {!isFFBEnabled ?? (
                <Grid item xs={12} sm={12} md={4}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Comments type={paymentType} id={+id} />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Logs
                      targetId={parseInt(id)}
                      targetType={paymentType}
                      title={i18n.t('payments.logs')}
                      height={439}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default PaymentDetails;
